import axios from 'axios'

const state = { 
    machines: [],
    extruders: [],
    compressionMolds: [],
    injectionMoulds: [],
    corrugator: [],
    //NEW DATA MANAGEMENT
    blewData: [],
    machines: [],
    mergedMachines: []
    //END NEW DATA MANAGEMENT
};

const getters = { 
    machinesList: state => state.machines
};

const actions = { 
    //FETCH MACHINES 
    async fetchmachines({commit}){ //OLD GET MACHINES KEEPING IT FOR REFERENCE
       const res = await axios.get('https://m4a.ramacsystems.com/backend/mechines/addGet.php?params', {
           params: {
               action: 'getMachines'
           }
       })
        const allMachines = res.data
        commit("setMachines", res.data)        
        commit('setExtruder', allMachines.filter(machine => machine.type == "Extruder"))
        commit('setCompressionMolds', allMachines.filter(machine => machine.type == "Compression Mould"))
        commit('setInjectionMoulds', allMachines.filter(machine => machine.type == "Injection Mould"))
        commit('setCorrugator', allMachines.filter(machine => machine.type == "Corrugator"))
    },

    async fetchDailyMachineData({commit}){
        const res = await axios.get('https://m4a.ramacsystems.com/backend/mechines/addGet.php?params', {
            params: {
                action: 'dailyBlewData'
            }
        })
        commit("setDailyMachineData", res.data)
        console.log(res.data)
    },
    //NEW DATA MANAGEMENT
        async fetchDailyMachineData1({ commit, dispatch }) { //OLD GET MACHINES KEEPING IT FOR REFERENCE
            const response = await axios.get('https://m4a.ramacsystems.com/backend/mechines/addGet.php?params&action=dailyBlewData')
                // {
                //         params: {
                //             action: 'dailyBlewData'
                //         }
                //     });
                    // const data = await response.json();
                    commit('setBlewData', response.data.blew_data);
                    commit('setMachines', response.data.machines);
                    dispatch('mergeData');
                },
                mergeData({ state, commit }) {
                    const merged = state.machines.map(machine => {
                    const relatedData = state.blewData
                        .filter(b => b.DeviceId === machine.ramacDevice)
                        .filter(b => {
                        const date = new Date(b.DateTimeUTC);
                        const today = new Date();
                        return date.toDateString() === today.toDateString();
                        });

                    const packetType1 = relatedData.filter(b => b.PacketType == 1);
                    const TotalProducts = packetType1.reduce((sum, b) => sum + Number(b.DigitalState || 0), 0);
                    const latest = relatedData.reduce((acc, b) => {
                        return new Date(b.DateTimeUTC) > new Date(acc.DateTimeUTC || 0) ? b : acc;
                    }, {});
                    return {
                        ...machine,
                        ID: latest.ID || null,
                        DateTimeUTC: latest.DateTimeUTC ? new Date(latest.DateTimeUTC).toLocaleString() : null,
                        PacketType: latest.PacketType || null,
                        POSTInterval: latest.POSTInterval || null,
                        TotalProducts,
                        differenceInSeconds: latest.differenceInSeconds || null,
                        PulseCount: latest.PulseCount || null,
                        curr_product: latest.curr_product || null
                    };
                    });
                    commit('setMergedMachines', merged);
                    commit('setExtruder', merged.filter(machine => machine.type == "Extruder"))
                    commit('setCompressionMolds', merged.filter(machine => machine.type == "Compression Mould"))
                    commit('setInjectionMoulds', merged.filter(machine => machine.type == "Injection Mould"))
                    commit('setCorrugator', merged.filter(machine => machine.type == "Corrugator"))
                }
            //END NEW DATA MANAGEMENT
        };
const mutations = { 
    setMachines: (state, machines) => (
        state.machines = machines
    ),
    setDailyMachineData: (state, dailyMachineData) => (
        state.dailyMachineData = dailyMachineData
    ),
    setExtruder: (state, extruders) => (
        state.extruders = extruders
    ),
    setCompressionMolds: (state, compressionMolds) => (
        state.compressionMolds = compressionMolds
    ),
    setInjectionMoulds: (state, injectionMoulds) => (
        state.injectionMoulds = injectionMoulds
    ),
    setCorrugator: (state, corrugator) => (
        state.corrugator = corrugator
    ),

    //NEW DATA MANAGEMENT
    setBlewData(state, data) {
        state.blewData = data;
    },
    setMachines(state, data) {
        state.machines = data;
    },
    setMergedMachines(state, data) {
        state.mergedMachines = data;
    }
    //END NEW DATA MANAGEMENT

};

export default {
    state,
    getters,
    actions,
    mutations
}